import { RootAppState } from 'store/configureStore'

export const geometryTypeSelectionEnabledInPortalSelector = (
  state: RootAppState,
): boolean => {
  return state.project.activeProject?.geometrySelectionEnabledInPortal ?? false
}
